"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.hasDismissedCookie = hasDismissedCookie;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Styles = _interopRequireWildcard(require("./style"));
var _Button = _interopRequireDefault(require("../Button"));
var _Icon = require("../Icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function setCookie(cookie, cookieKey, days, value) {
  const expiresInDays = days * 24 * 60 * 60;
  document.cookie = `${cookieKey}=${value}; max-age=${expiresInDays}; ${cookie}`;
}
function hasDismissedCookie(cookie, cookieKey) {
  const match = cookie.match(new RegExp(`${cookieKey}=dismissed;*`));
  if (match) {
    return true;
  }
  return false;
}
class Modal extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onKeyDown = event => {
      if (event.which === 27) {
        event.preventDefault();
        event.stopPropagation();
        if (this.props.closeButton) {
          this.props.closeButton.callback();
        }
        this.dismiss();
      }
    };
    this.validateAction = action => {
      if (action && action.label && action.callback) {
        return true;
      }
      return false;
    };
    if (props.cookie) {
      this.state = {
        dismissed: hasDismissedCookie(props.cookie.store, props.cookie.store)
      };
    }
  }
  componentDidMount() {
    if (this.ctaButton) {
      this.ctaButton.focus();
    }
    if (this.modal) {
      this.modal.addEventListener('keydown', this.onKeyDown);
      this.modal.focus();
      if (this.props.closeButton) {
        this.container.addEventListener('click', e => this.clickToClose(e));
      }
    }
  }
  componentWillUnmount() {
    if (this.modal) {
      this.modal.removeEventListener('keydown', this.onKeyDown);
    }
  }
  handleAction(action) {
    if (action.callback) {
      action.callback();
    }
    if (this.props.dismissible) {
      this.dismiss();
    }
  }
  clickToClose(e) {
    if (e.target !== this.container) return;
    this.props.closeButton.callback();
    this.dismiss();
  }
  dismiss() {
    const {
      cookie
    } = this.props;
    this.setState({
      dismissed: true
    });
    if (cookie) {
      setCookie(cookie.store, cookie.key, cookie.days, 'dismissed');
    }
    if (this.props.previousFocus && this.props.previousFocus.current) {
      this.props.previousFocus.current.focus();
    }
  }
  render() {
    const {
      children,
      background,
      action,
      secondaryAction,
      footer,
      width,
      noBackground,
      closeButton,
      accessibility
    } = this.props;
    const ariaProps = accessibility ? Object.assign({}, accessibility.ariaLabelledby && {
      'aria-labelledby': accessibility.ariaLabelledby,
      'aria-describedby': accessibility.ariaDescribedby
    }) : {};
    if (this.state && this.state.dismissed) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(Styles.Container, {
      ref: container => this.container = container
    }, /*#__PURE__*/_react.default.createElement(Styles.Modal, Object.assign({
      background: background,
      ref: modal => this.modal = modal,
      width: width,
      tabIndex: "0",
      noBackground: noBackground,
      "aria-modal": "true"
    }, ariaProps), closeButton && ( /*#__PURE__*/_react.default.createElement(Styles.IconContainer, {
      onClick: () => {
        this.handleAction(closeButton);
      },
      noBackground: noBackground,
      type: "button",
      "aria-label": "Close"
    }, /*#__PURE__*/_react.default.createElement(_Icon.Cross, {
      size: "large"
    }))), children, /*#__PURE__*/_react.default.createElement(Styles.Footer, {
      background: background
    }, footer, this.validateAction(secondaryAction) && ( /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "text",
      onClick: () => {
        this.handleAction(secondaryAction);
      },
      disabled: secondaryAction.disabled,
      label: secondaryAction.label
    })), this.validateAction(action) && ( /*#__PURE__*/_react.default.createElement(_Button.default, {
      buttonRef: ctaButton => this.ctaButton = ctaButton,
      type: action.type || 'primary',
      onClick: () => {
        this.handleAction(action);
      },
      disabled: action.disabled,
      label: action.label
    })))));
  }
}
Modal.propTypes = {
  background: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  action: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    disabled: _propTypes.default.bool,
    callback: _propTypes.default.func,
    type: _propTypes.default.string
  }),
  dismissible: _propTypes.default.bool,
  secondaryAction: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    disabled: _propTypes.default.bool,
    callback: _propTypes.default.func
  }),
  cookie: _propTypes.default.shape({
    days: _propTypes.default.number,
    store: _propTypes.default.string.isRequired,
    key: _propTypes.default.string.isRequired
  }),
  footer: _propTypes.default.node,
  previousFocus: _propTypes.default.node,
  width: _propTypes.default.string,
  noBackground: _propTypes.default.bool,
  closeButton: _propTypes.default.shape({
    callback: _propTypes.default.func.isRequired
  }),
  accessibility: _propTypes.default.shape({
    ariaLabelledby: _propTypes.default.string,
    ariaDescribedby: _propTypes.default.string
  })
};
Modal.defaultProps = {
  background: null,
  cookie: null,
  action: null,
  secondaryAction: null,
  footer: null,
  previousFocus: null,
  dismissible: true,
  width: null,
  noBackground: false,
  closeButton: null
};
var _default = exports.default = Modal;